import React from 'react';

/**
 * Заглушки и ошибка с повтором — общие для всех экранов каталога.
 *
 * Заглушка повторяет форму того, что приедет: ряд постеров — рядом постеров,
 * сетка — сеткой. Тогда приехавшее содержимое встаёт на её место, ничего не
 * сдвигая, а экран с первой секунды выглядит как экран, а не как пустота с
 * надписью «Загрузка…».
 */

/** Одна карточка-заглушка: постер и две строки подписи. */
function SkeletonCard({ wide = false }: { wide?: boolean }): React.JSX.Element {
  return (
    <span className={wide ? 'card-placeholder card-placeholder--wide' : 'card-placeholder'}>
      <span className="skeleton-block card-placeholder-art" />
      <span className="skeleton-block card-placeholder-line" />
      <span className="skeleton-block card-placeholder-line is-short" />
    </span>
  );
}

/** Ряд-заглушка с заголовком: столько карточек, сколько примерно влезает. */
export function RailSkeleton({ wide = false, count = 8 }: { wide?: boolean; count?: number }): React.JSX.Element {
  return (
    <section className="catalog-section" aria-hidden="true">
      <span className="skeleton-block rail-placeholder-title" />
      <div className="rail rail--static">
        {Array.from({ length: count }, (_, index) => (
          <SkeletonCard key={index} wide={wide} />
        ))}
      </div>
    </section>
  );
}

/** Сетка-заглушка для разделов, избранного, истории и фильмографии. */
export function GridSkeleton({ count = 12 }: { count?: number }): React.JSX.Element {
  return (
    <div className="grid" aria-busy="true" aria-label="Загрузка…">
      {Array.from({ length: count }, (_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
}

/**
 * Ошибка загрузки с «Повторить»: сказать, что не вышло, мало — нужно дать
 * способ попробовать снова, не перезагружая всю вкладку.
 */
export function RetryError({ message, onRetry }: { message: string; onRetry: () => void }): React.JSX.Element {
  return (
    <div className="state error state-retry" role="alert">
      <span>{message}</span>
      <button type="button" className="secondary-action" onClick={onRetry}>
        Повторить
      </button>
    </div>
  );
}
